import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Sidebar from '../views/template/view.sidebar';
import Navbar from '../views/template/view.navbar';
import Dashboard from '../views/dashboard/view.dashboard';
import Products from '../views/products/view.products';
import Purchases from '../views/purchases/view.purchases';
import Sales from '../views/sales/view.sales';
import Campaigns from '../views/campaigns/view.campaigns';
import Investments from '../views/investments/view.investments';
import Partners from '../views/partners/view.partners';
import Companies from '../views/companies/view.companies';
import Profile from '../views/profile/view.profile';
import CagnotteList from '../views/cagnotte/view.cagnotte';
import CagnotteDetail from '../views/cagnotte/view.cagnotte.detail';

export default function BasicRouting() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const user = useSelector(s => s.userReducer.user);
  const isInvestor = user?.role === 'investisseur';

  // Close the mobile drawer on navigation
  useEffect(() => { setMobileOpen(false); }, [pathname]);

  // Lock page scroll behind the open drawer; close it with Escape
  useEffect(() => {
    if (!mobileOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => e.key === 'Escape' && setMobileOpen(false);
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [mobileOpen]);

  return (
    <div className="app-layout">
      <Sidebar
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
        collapsed={sidebarCollapsed}
        onToggleCollapsed={() => setSidebarCollapsed(c => !c)}
      />
      <div className={`app-main ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Navbar
          sidebarCollapsed={sidebarCollapsed}
          onMobileMenuToggle={() => setMobileOpen(true)}
        />
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/products" element={<Products />} />
          <Route path="/purchases" element={<Purchases />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/investments" element={<Investments />} />
          <Route path="/companies" element={<Companies />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/cagnotte" element={<CagnotteList />} />
          <Route path="/cagnotte/:id" element={<CagnotteDetail />} />
          {isInvestor && <Route path="/partners" element={<Partners />} />}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </div>
  );
}
